
export const StatusEnum = {
  // ACTIVE: 0,
  // INACTIVE: 1,
  options: [
    {id: 'Active', text: '启用'},
    {id: 'Inactive', text: '停用'}
  ],
};

export const OpTypeEnum = {
  // ADD: 0,
  // EDIT: 1,
  // DELETE: 2,
  options: [
    {id: null, text: '全部'},
    {id: 'Add', text: '新增'},
    {id: 'Update', text: '编辑'},
    {id: 'Delete', text: '删除'},
  ],
};
